module.exports = __webpack_public_path__ + "static/media/18 April _Header Logo.5ca7424a.bin";